import React from "react";
import { createRoot } from "react-dom/client";
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import App from "./App";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports.js";
import { logEnvironmentInfo } from "./utils/apiLogger";

// Configure Amplify
Amplify.configure(awsExports);

// Log environment info on startup
logEnvironmentInfo();

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Authenticator>
    {({ signOut, user }) => (
      <App />
    )}
  </Authenticator>
);
